import React from 'react';
import { ListItem, ListItemText } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CustomStyleListItem } from './Styles';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @Description List container with dynamic content
 * @param Integer index: Key identifier for option (required)
 * @param String classes: Add extra classes in option item (optional)
 * @param Array<JSX.Element> children: List of JSX elements (required)
 * @param Array<JSX.Element> actions: List of JSX elements for actions (optional)
 * @param String text: Text for item (optional)
 * @param String textClasses: Add extra classes in the item text (optional)
 * @returns {JSX.Element}
 */
const CustomListItem = ({ index, classes, children, actions, text, textClasses = '', onClick = () => {}, display = '' ,  color = 'var(--shades-400)'}) => {
    const { t } = useTranslation();
    return (
        <ListItem
            className={"mb-1 "+ classes}
            key={index}
            sx={CustomStyleListItem(display, color)}
            onClick={onClick}
        >
            {text &&
                <ListItemText
                    primary={t(text)}
                    className={"text-break"}
                    primaryTypographyProps={{ className: textClasses }}
                />
            }
            {children}

            {actions && <div className={'custom-list-actions'}>{actions}</div>}
        </ListItem>
    );
};

export default CustomListItem;
